// constants.js

const CONTACT_EMAIL = "contact@microURLS.com";
const CONTACT_PHONE = +911234567890;
const reCAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;
const APP_BASE_URL = process.env.REACT_APP_HOST;
const API_BASE_URL = process.env.REACT_APP_API_HOST;
export {
    CONTACT_EMAIL, CONTACT_PHONE, APP_BASE_URL, API_BASE_URL, reCAPTCHA_KEY
};
